import Api from "./Api";

export default {
  deleteRequest(url, data) {
    return Api().delete(url, {
      data: data
    });
  },

  getRequest(url, params) {
    return Api().get(url, {
      params: params
    });
  },

  getFiles(url) {
    return Api().get(url, {
      responseType: "arraybuffer"
    });
  },

  postRequest(url, data) {
    return Api().post(url, {
      data: data
    });
  },

  postFiles(url, data) {
    return Api().post(url, data, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  },

  putRequest(url, data) {
    return Api().put(url, {
      data: data
    });
  }
};
